import { AlertTriangle } from "lucide-react"
import { Button } from "../../shadcn/button"

interface ErrorStateProps {
  error: string;
  onClose: () => void;
}

const ErrorState = ({ error, onClose }: ErrorStateProps) => {
  return (
    <div className="py-16 text-center">
      <div className="bg-red-100 dark:bg-red-900/30 p-4 rounded-full inline-flex mx-auto">
        <AlertTriangle className="h-8 w-8 text-red-600 dark:text-red-500" />
      </div>
      <p className="mt-4 text-red-600 dark:text-red-500 max-w-xs mx-auto">{error}</p>
      <Button 
        variant="outline" 
        size="sm" 
        className="mt-4 dark:border-gray-700 dark:hover:bg-gray-700/50" 
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
      >
        Fermer
      </Button>
    </div>
  )
}

export default ErrorState